import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getCategoryBySlug, getCategoryPages } from '../utils/seoPageLoader';
import SEO from '../components/SEO';

function CategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cat = getCategoryBySlug(slug);
    if (cat) {
      setCategory(cat);
      setPages(getCategoryPages(slug));
    }
    setLoading(false);
  }, [slug]);

  if (loading) {
    return (
      <div className="text-center py-16">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="text-center py-16">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Category not found</h1>
        <Link to="/" className="text-gray-600 hover:text-gray-800 underline">
          Back to Home
        </Link>
      </div>
    );
  }

  return (
    <div>
      <SEO 
        title={`${category.title} | Mood Food Recommender`} 
        description={category.description} 
      />
      
      <div className="bg-white rounded-xl shadow-sm border p-6 mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{category.title}</h1>
        <p className="text-gray-600 mb-6 text-lg">{category.intro}</p>
        
        <div className="mb-6">
          <Link
            to="/"
            className="inline-block bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition"
          >
            Try the Mood Food Tool
          </Link>
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          All Guides ({pages.length})
        </h2>
        <div className="grid md:grid-cols-2 gap-4">
          {pages.map((page) => (
            <Link
              key={page.slug}
              to={`/guides/${page.slug}`}
              className="p-5 rounded-lg border hover:bg-gray-50 transition"
            >
              <h3 className="font-semibold text-gray-900 mb-2">
                {page.title}
              </h3>
              <p className="text-sm text-gray-600">
                {page.description}
              </p>
            </Link>
          ))}
        </div>
      </div>

      <div className="mb-8">
        <Link
          to="/"
          className="text-gray-600 hover:text-gray-800 underline"
        >
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}

export default CategoryPage;
